import React, {memo, useState, useEffect} from 'react';
import Image from 'next/image';
import {useRouter} from 'next/router';

import CloseImg from '@imageWrapper/closeImg';

function MobileFilter(props) {
	const {styles, filters, url} = props;
	return (
		<>
			<div className={styles.mobileFilter}>
				<ul
					className={`d-flex align-items-center justify-content-between ${styles.positionUl}`}
				>
					<li>
						<h6>Wishlist Details</h6>
					</li>
					<SortBy styles={styles} filters={filters} pageUrl={url} />
				</ul>
			</div>
		</>
	);
}

const wrapperRef = React.createRef();
const sortItems = {
	1: 'Newest First',
	2: 'Price low to high',
	3: 'Price high to low',
	4: 'Alphabetical A-Z',
	5: 'Alphabetical Z-A',
};

function SortBy(props) {
	const router = useRouter();
	const [show, setShow] = useState(false);
	const {styles, filters} = props;

	useEffect(() => {
		const outSideModalClickEvent = () => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setShow(false);
				// removeListener();
			}
		};
		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);

		return () => removeListener;
	}, []);

	const sortby = sort => {
		setShow(false);
		const query = {...props.filters, sortBy: sort};
		if (filters.sortBy && sort === filters.sortBy) return;
		if (sort === 1) delete query.sortBy;
		delete query.page;
		router.push({pathname: props.pageUrl, query});
	};
	const hideShow = () => {
		setShow(false);
	};
	useEffect(() => {
		if (show) {
			document.body.style.overflowY = 'hidden';
		} else {
			document.body.style.removeProperty('overflow-y');
		}
	}, [show]);
	return (
		<>
			<li>
				<div className={styles.sortImage} onClick={() => setShow(true)}>
					<Image src={'/assets/images/sort.png'} fill sizes='100vw' />
				</div>
			</li>
			{show && (
				<>
					<div className={styles.mobSortOverlay}></div>
					<div className={styles.mobSortContents} ref={wrapperRef}>
						<div className={styles.closeButtonSort} onClick={hideShow}>
							<CloseImg click={hideShow} />
						</div>{' '}
						<ul>
							{Object.keys(sortItems).map(k => (
								<li key={k}>
									<a onClick={() => sortby(k)}>{sortItems[k]}</a>
								</li>
							))}
						</ul>
					</div>
				</>
			)}
		</>
	);
}

export default memo(MobileFilter);
